import { all, takeEvery, put, call } from 'redux-saga/effects';
import moment from 'moment';
import actions from './actions';
import Api from '../../../../helpers/api';
import { t } from '../../../../i18n';
import { sendRequest } from '../../../../helpers/saga';
import notifications from '../../../../redux/notifications/actions';
import { logger } from '../../../../helpers/logger';

const requestedBackgoundChecksApi = new Api('workers/:id/background_checks?pageSize=9999');
const suggestedBackgoundChecksApi = new Api('workers/:id/background_checks/suggested?pageSize=9999');
const addManuallyApi = new Api('workers/:id/background_checks/add_manually');

function* loadData({ payload }) {
  try {
    const { id } = payload;

    const { requestedChecks, suggestedChecks } = yield all({
      requestedChecks: call(sendRequest, requestedBackgoundChecksApi.load, { id }, notifications.REQUEST_ERROR),
      suggestedChecks: call(sendRequest, suggestedBackgoundChecksApi.load, { id }, notifications.REQUEST_ERROR),
    });

    if (requestedChecks?.data?.success?.data) {
      yield put(
        actions.loadDataSuccess({
          requestedChecks: requestedChecks.data.success.data.records.map(item => {
            item.disabled = item.expiry && moment().isAfter(moment(item.expiry));
            item.parent = true;
            item.children = item.children.map(child => {
              child.disabled = child.expiry && moment().isAfter(moment(child.expiry));

              return child;
            });

            return item;
          }),
          suggestedChecks: suggestedChecks.data.success.data.records,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* createBackgroundCheck({ payload }) {
  try {
    const { url, id } = payload;

    const result = yield call(sendRequest, new Api(url).createItem, {}, notifications.REQUEST_ERROR);

    if (result && result.data) {
      yield put(actions.loadData({ id }));

      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.talent.background_check_ordered_successfully'),
        }),
      );
    } else {
      yield put(actions.createBackgroundCheckError());
    }
  } catch (error) {
    logger.error(error);
  }
}

function* reorderBackgroundCheck({ payload }) {
  try {
    const { url, id } = payload;

    const result = yield call(sendRequest, new Api(url).createItem, {}, notifications.REQUEST_ERROR);

    if (result && result.data) {
      yield put(actions.loadData({ id }));

      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.talent.background_check_reordered_successfully'),
        }),
      );
    } else {
      yield put(actions.reorderBackgroundCheckError());
    }
  } catch (error) {
    logger.error(error);
  }
}

function* submitManuallyBackgroundCheck({ payload }) {
  try {
    const { accreditation_submission, id } = payload;

    const result = yield call(
      sendRequest,
      addManuallyApi.createItem,
      { data: { accreditation_submission }, id },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      if (result.data) {
        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.success_headline'),
            type: 'success',
            message: t('dash.common.notification.added_successfully', {
              item: t('dash.talent.background_check_title'),
            }),
          }),
        );

        yield put(actions.loadData({ id }));
        yield put(actions.toggleBackgroundCheckModal());
      } else {
        yield put(actions.saveError({ data: result }));
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD_REQUEST, loadData),
    takeEvery(actions.CREATE_BACKGROUND_CHECK, createBackgroundCheck),
    takeEvery(actions.REORDER_BACKGROUND_CHECK, reorderBackgroundCheck),
    takeEvery(actions.SUBMIT_MANUALLY_BACKGROUND_CHECK_REQUEST, submitManuallyBackgroundCheck),
  ]);
}
